import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';

import Landing from './pages/Landing/Landing';
import Articles from './pages/Articles/Articles';
import ArticleView from './pages/Articles/ArticleView';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import YandexCallback from './pages/Auth/YandexCallback';
import GoogleCallback from './pages/Auth/GoogleCallback';
import Cabinet from './pages/Cabinet/Cabinet';
import Admin from './pages/Admin/Admin';
import Oferta from './pages/Legal/Oferta';
import Privacy from './pages/Legal/Privacy';
import NotFound from './pages/NotFound';

import useUserStore from './store/userStore';

// При смене маршрута поднимаем страницу вверх. Это удобнее, чем
// сохранение скролла Реактом, для лендинга с длинными секциями.
function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        // Если есть якорь — оставляем браузеру (например, /#tariff)
        if (hash) return;
        window.scrollTo(0, 0);
    }, [pathname, hash]);
    return null;
}

export default function App() {
    const refresh = useUserStore(s => s.refresh);

    // Один раз при загрузке приложения подтягиваем профиль (если есть токен).
    useEffect(() => { refresh(); }, [refresh]);

    return (
        <>
            <ScrollToTop/>
            <Header/>

            <Routes>
                <Route path="/" element={<Landing/>}/>
                <Route path="/articles" element={<Articles/>}/>
                <Route path="/articles/:id" element={<ArticleView/>}/>
                <Route path="/login" element={<Login/>}/>
                <Route path="/registration" element={<Register/>}/>
                {/* OAuth callback'и: Yandex/Google редиректят сюда после авторизации. */}
                <Route path="/auth/yandex/callback" element={<YandexCallback/>}/>
                <Route path="/auth/google/callback" element={<GoogleCallback/>}/>
                <Route path="/cabinet" element={<Cabinet/>}/>
                {/* Админ-раздел: доступ проверяет бэкенд (role=admin), 403 остальным. */}
                <Route path="/admin" element={<Admin/>}/>
                <Route path="/oferta" element={<Oferta/>}/>
                <Route path="/privacy" element={<Privacy/>}/>
                <Route path="*" element={<NotFound/>}/>
            </Routes>

            <Footer/>
        </>
    );
}
